import React__default, { Children } from 'react';

/**
 * Function to ungroup children and to filter out
 * children that are not menu items
 * @param children
 * @returns Flat list of menu items
 */
const unwrapMenuItems = (children = []) => Children.map(children, child => {
  if (!React__default.isValidElement(child)) {
    return null;
  }
  if ('children' in child.props) {
    return unwrapMenuItems(child.props.children);
  }
  return child;
}).flat().filter(child => !!child.props.item);

export { unwrapMenuItems };
//# sourceMappingURL=unwrapMenuItems.js.map
